export default "__VITE_ASSET__CQ_2517x__"